module.exports = __webpack_public_path__ + "img/6544.d54ada9d.jpg";